import { motion } from 'framer-motion'
import { Icon } from '@iconify/react'
import searchFill from '@iconify/icons-eva/search-fill'
// material
import {
  experimentalStyled as styled,
  useTheme,
} from '@material-ui/core/styles'
import {
  Box,
  alpha,
  Container,
  OutlinedInput,
  InputAdornment,
  Link,
  Grid,
  Typography,
  Chip,
  Avatar,
  Stack,
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Divider,
} from '@material-ui/core'
//
import {
  varFadeInUp,
  TextAnimate,
  MotionInView,
  varWrapEnter,
  varFadeInDown,
  varFadeInLeft,
} from '../../animate'
import {
  Done,
  Email,
  Language,
  Message,
  Print,
  School,
  Wifi,
} from '@material-ui/icons'
import { useLocation, useNavigate, useParams } from 'react-router'
import Markdown from 'src/components/Markdown'
import RelatedCaseStudyCarousal from '../about/RelatedCaseStudyCarousal'
import { EcommerceNewProducts } from 'src/components/_dashboard/general-ecommerce'
import CaseStudyListItems from './CaseStudyListItems'
import { MIconButton } from 'src/components/@material-extend'
import { keyframes } from '@emotion/react'
import Maintenance from 'src/pages/Maintenance'
import Events from '../../../images/Slider-2.png'
import { useRef } from 'react'
import HomeContactForm from './HomeContactForm'
import { Helmet } from 'react-helmet'
import UpcomingEventsCard from './UpcomingEventCard'
import ConductedEvents from './ConductedEvents'
import SkynicheAIServices from './SkynicheAIServices'
import AIIntelligentAutomationCards from './AIIntelligentAutomationCards'
import { useState } from 'react'

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 88
const APP_BAR_DESKTOP_SMALL = 52

const RootStyle = styled(motion.div)(({ theme }) => ({
  marginTop: '128px',
}))

// ----------------------------------------------------------------------

const ToolbarStyle1 = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_DESKTOP_SMALL,
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  backgroundColor: '#027dc2',
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP_SMALL,
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  zIndex: 999,
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    position: 'absolute',
    top: theme.spacing(5),
  },
}))

// Define the fade-in keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const RootStyle1 = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  opacity: 0,
  animation: `${fadeIn} 0.5s ease-in forwards`,
  [theme.breakpoints.up('md')]: {
    height: 510,
    padding: 0,
  },
}))

export default function ServicesAiIntelligentAutomation() {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const {
    date,
    imgSrc,
    title1,
    description,
    description1,
    category,
    subheading,
    points,
    pointsDescription,
    reflectionDescription,
    brandIdentity,
    SEO,
    time,
    designElements,
    conclusion,
  } = location.state || {}
  const contactRef = useRef(null)

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <RootStyle initial="initial" animate="animate" variants={varWrapEnter}>
      <Helmet>
        <title>
          Leader in custom software development, IT services, and solutions.
        </title>
        <meta
          name="description"
          content="At skyniche Technologies, our mission is to empower businesses with innovative and reliable software solutions. We transform ideas into reality, helping clients excel in their industries and achieve their goals. Driven by a for technology and excellence, we deliver exceptional value and make a meaningful impact."
        />
        <meta name="keywords" content="Events skyniche Technologies" />
      </Helmet>
      <Grid
        sx={{
          boxShadow: 0,
          height: '60px',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          marginTop: { xs: '-38px', sm: '-38px', md: 0 },
          marginBottom: { xs: '-3px', sm: '-3px', md: 0 },
        }}
      >
        <ToolbarStyle1 disableGutters>
          <Container
            maxWidth="lg"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: { xs: 0, sm: 0, md: -0.5 },
            }}
          >
            <Stack sx={{ display: 'flex', flexDirection: 'column' }}>
              <MotionInView variants={varFadeInUp}>
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#fff',
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  Services
                </Typography>
              </MotionInView>
            </Stack>

            <MotionInView variants={varFadeInUp}>
              <Button
                variant="outlined"
                sx={{
                  color: '#c9fbfa',
                  border: '2px solid #c9fbfa',
                  fontWeight: '600',
                  borderRadius: 5,
                  fontFamily:
                    '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  '&:hover': { border: '2px solid #c9fbfa', color: '#c9fbfa' },
                  backgroundColor: 'transparent',
                }}
                startIcon={
                  <Stack
                    className="tabler--message"
                    sx={{ fontSize: '1.4rem' }}
                  />
                }
                onClick={scrollToContact}
              >
                Contact
              </Button>
            </MotionInView>
          </Container>
        </ToolbarStyle1>
      </Grid>
      <RootStyle1
        initial="initial"
        sx={{ backgroundSize: 'cover', backgroundImage: `url(${Events})` }}
        animate="animate"
        variants={varWrapEnter}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', height: '100%' }}>
          <ContentStyle>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              sx={{ mt: { xs: -4, sm: -4, md: 0 } }}
            >
              <MotionInView variants={varFadeInUp}>
                <Link
                  underline="none"
                  sx={{
                    textAlign: 'left',
                    fontSize: '75px',
                    lineHeight: '1.2',
                    fontWeight: '500',
                    color: '#fff',
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  AI & Intelligent Automation
                </Link>
              </MotionInView>
            </Grid>
          </ContentStyle>
        </Container>
      </RootStyle1>
      <Box
        maxWidth="lg"
        sx={{
          pt: 5,
          pb: 3,
          pl: { xs: 3, sm: 3, md: 6 },
          pr: { xs: 3, sm: 3, md: 6 },
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              mb: 2,
              pl: 2,
            }}
          >
            <MotionInView variants={varFadeInUp}>
              <AIIntelligentAutomationCards />
            </MotionInView>
            <Box sx={{ mt: 1 }} ref={contactRef}>
              <HomeContactForm />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </RootStyle>
  )
}
